import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Typography, message } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { ROUTES } from '../../constants/routes';
import VolunteerRegistrationService from '../../services/VolunteerRegistrationService';
import {
  SuccessContainer,
  IconContainer,
  HeartIcon,
  StyledTitle,
  ActionButton,
  DownloadSection,
  PdfIcon,
  DownloadButton,
  EventInfo,
  ButtonGroup
} from './styled';

const { Paragraph } = Typography;

const VolunteerSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [downloading, setDownloading] = useState(false);
  
  // Get registration data from navigation state
  const { registrationId, downloadToken, fullName, eventName } = location.state || {};

  const goToHome = () => {
    navigate(ROUTES.HOME);
  };

  const handleDownloadPdf = async () => {
    if (!registrationId || !downloadToken) {
      message.error('Unable to download PDF. Registration information not found.');
      return;
    }

    try {
      setDownloading(true);
      const response = await VolunteerRegistrationService.downloadPdf(registrationId, downloadToken);
      
      if (response.success) {
        // Create blob URL and trigger download
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `volunteer-waiver-${registrationId}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        message.success('Waiver PDF downloaded successfully!');
      } else {
        message.error(response.message || 'Failed to download PDF');
      }
    } catch (error) {
      console.error('Error downloading PDF:', error);
      message.error('Failed to download PDF. Please try again.');
    } finally {
      setDownloading(false);
    }
  };

  return (    <SuccessContainer>
      <IconContainer>
        <HeartIcon />
      </IconContainer>
        <StyledTitle level={2}>Thank You for Volunteering!</StyledTitle>
      
      {fullName && (
        <Paragraph style={{ fontSize: '20px', color: '#4A90E2', fontWeight: 600, marginBottom: '8px' }}>
          {fullName}
        </Paragraph>
      )}
      
      <Paragraph style={{ fontSize: '18px', color: '#333', marginBottom: '16px', lineHeight: '1.6' }}>
        Your volunteer registration has been successfully submitted. We&apos;re excited to have you join our mission 
        of promoting heart health in our communities!
      </Paragraph>
      
      {eventName && (
        <EventInfo>
          <p><strong>Registered Event:</strong> {eventName}</p>
          <p style={{ marginTop: '8px', color: '#666', fontSize: '13px' }}>
            You will receive a confirmation email with more details about your volunteer assignment.
          </p>
        </EventInfo>
      )}
      
      {registrationId && downloadToken && (
        <DownloadSection>
          <PdfIcon />
          <Paragraph style={{ fontSize: '14px', color: '#333', margin: 0, textAlign: 'center' }}>
            Your signed waiver is ready for download. Keep this for your records.
          </Paragraph>
          <DownloadButton 
            onClick={handleDownloadPdf}
            loading={downloading}
            icon={<DownloadOutlined />}
          >
            Download Signed Waiver
          </DownloadButton>
        </DownloadSection>
      )}
      
      <Paragraph style={{ fontSize: '16px', color: '#666', marginBottom: '24px', lineHeight: '1.6' }}>
        Our team will contact you soon with more details about your selected volunteer opportunity. 
        Together, we can make a difference in cardiovascular health awareness and prevention.
      </Paragraph>
        
      <ButtonGroup>
        <ActionButton 
          type="primary"
          size="large"
          onClick={goToHome}
        >
          Return to Home
        </ActionButton>
      </ButtonGroup>
    </SuccessContainer>
  );
};

export default VolunteerSuccess;
